import { useTranslation } from "react-i18next";

const AiInsightsSection = () => {
  const { t } = useTranslation();
  const paragraphs = t("aiInsightsSection.paragraphs", { returnObjects: true });
  const titleLines = t("aiInsightsSection.titleLines", { returnObjects: true });

  return (
    <section className="ai-insights position-relative z-index-1 overflow-hidden">
      <div className="ai-insights__stage">
        <div className="ai-insights__visual">
          <div className="ai-insights__glow" />
          <img
            src="/assets/images/thumbs/ai-section/ai-icon.png"
            alt=""
            className="ai-insights__icon"
          />
          <img
            src="/assets/images/thumbs/ai-section/ai-section-visual.png"
            alt={t("aiInsightsSection.imageAlt")}
            className="ai-insights__image"
          />
        </div>

        <div className="section-content ai-insights__content">
          <div className="section-heading style-left">
            <h3 className="section-heading__title ai-insights__title">
              {titleLines.map((line, index) => (
                <span key={index}>{line}</span>
              ))}
            </h3>
            {paragraphs.map((paragraph, index) => (
              <p className="section-heading__desc font-18" key={index}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiInsightsSection;
